import { SampleBoardValidateCheck } from "@app/strain/sample-boards/models/validate/sample-board-validate-check.model";
import {SampleBoardItem} from "@app/strain/sample-boards/models/sample-board-item.model";

export enum SampleBoardValidateItemStatus {
    Pending = 1,
    Completed = 2,
}

export class SampleBoardValidateItem {
    id: number;
    status: SampleBoardValidateItemStatus;
    sampleBoardItem: SampleBoardItem;

    checks: SampleBoardValidateCheck[];

    constructor(entry: any = {}) {
        this.id = entry?.id;
        this.status = entry?.status;
        this.sampleBoardItem = entry?.sampleBoardItem ? new SampleBoardItem(entry?.sampleBoardItem) : null;
        this.checks = entry?.checks ? entry.checks.map(
            (ntry) => new SampleBoardValidateCheck(ntry)) : [];

    }
}
